<div class="flex items-stretch justify-between gap-12 children:w-1/2 children:flex-1 ">
  <app-card class="w-full">
    <div class="flex flex-col p-4 ">
      <div class="flex flex-col lg:flex-row">
        <div class="ballot-summary-title" id="ballot-summary">Ballot Summary</div>
        <app-ballot-status-badge class="mt-2 ml-auto" [statusId]="ballotStatusId">
        </app-ballot-status-badge>
      </div>


      <div class="mt-8 text-grey-800">
        <div class="flex flex-col lg:flex-row">
          <div class="lg:w-1/2">
            <div id="div-published-date">
              <label class="ballot-summary-label" id="ballot-summary-published-date-label">IEC Link</label>

              <p *ngIf="iecBallotDetail?.ballotSummary?.iecLink == ''">-</p>
              <p *ngIf="iecBallotDetail?.ballotSummary?.iecLink != ''">
                <a href={{iecBallotDetail?.ballotSummary?.iecLink}} target="_blank"
                class="block mt-1 overflow-hidden leading-6 cursor-pointer text-link text-ellipsis whitespace-nowrap"
                id="">{{iecBallotDetail?.ballotSummary?.iecLink != '' && iecBallotDetail?.ballotSummary?.iecLink != null ? truncate(iecBallotDetail?.ballotSummary?.iecLink) : '-'}}</a>
              </p>

            </div>
            <div id="div-committee">
              <label class="ballot-summary-label" id="ballot-summary-committee-label">Committee</label>
              <a id="ballot-summary-committee-value"
                [routerLink]="['/committees', iecBallotDetail?.ballotSummary?.committeeCode]"
                class="block overflow-hidden leading-6 whitespace-pre-wrap text-link text-ellipsis">
                <p>{{getCommitteeName()}}</p>
              </a>
            </div>

            <div id="div-project-manager">
              <label for="ballot-project-manager">Lead</label>
              <p class="body-default-regular">
                <a
                  class="body-default-regular text-link"
                  id="a-ballot-project-manager"
                  href="mailto:{{
                    iecBallotDetail?.ballotSummary?.projectManagerEmail
                  }}"
                >
                  {{ iecBallotDetail?.ballotSummary?.projectManagerName }}
                </a>
              </p>
            </div>

            <div id="div-Associated-Documents">
              <label class="mb-2 ballot-summary-label" id="ballot-summary-associated-documents-label">Associated
                Documents</label>
              <a (click)="downloadDraft()"
                class="block overflow-hidden leading-6 cursor-pointer text-link text-ellipsis whitespace-nowrap"
                id="ballot-summary-associated-documents-value">{{draftFile != null ? truncate(draftFile?.overview?.metadata?.filename) : '-' }}</a>

            </div>
          </div>
          <form class="lg:w-1/2" [formGroup]="ballotSummaryDateForm">
            <div id="div-Ballot-Start-Date">
              <ng-container *ngIf="isBallotStartDateEditable; else displayStartDate">
                <app-date-picker formControlName="ballotStartDateCtrl" id="Ballot-Start-Date" name="startDate"
                  label="Start Date" placeholder="Select date" [value]="ballotStartDate" [minDate]="ballotStartMinDate"
                  [maxDate]="ballotStartMaxDate" [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayStartDate>
                <label class="ballot-summary-label" id="Ballot-Start-Date-label">Start Date</label>
                <p class="ballot-summary-value" id="Ballot-Start-Date-input"
                  [attr.displayDate]="iecBallotDetail?.ballotSummary?.startDate | dateFormat">
                  {{ iecBallotDetail?.ballotSummary?.startDate | dateFormat }}
                </p>
              </ng-template>
            </div>
            <div id="div-Ballot-End-Date">
              <ng-container *ngIf="isBallotEndDateEditable; else displayBallotEndDate">
                <app-date-picker formControlName="ballotEndDateCtrl" id="Ballot-End-Date" name="endDate"
                  label="End Date" placeholder="Select date" [value]="ballotEndDate" [minDate]="ballotEndMinDate"
                  [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayBallotEndDate>
                <label class="ballot-summary-label" id="Ballot-End-Date-label">End Date</label>
                <p class="ballot-summary-value" id="Ballot-End-Date-input"
                  [attr.displayDate]="iecBallotDetail?.ballotSummary?.endDate | dateFormat">
                  {{ iecBallotDetail?.ballotSummary?.endDate | dateFormat }}
                </p>
              </ng-template>
            </div>
          </form>
        </div>

        <div class="my-4 border-b border-gray-200"></div>

        <div class="mb-4 body-default-bold">Notes</div>

        <div *ngIf="!isAuthorized" class="ballot-summary-value">{{note??''}}</div>
        <app-text-area *ngIf="isAuthorized" id="ballot-note" title="Note" (input)="onInput($event)" [(ngModel)]="note"
          [disabled]="!isAuthorized" [rows]="6"></app-text-area>

        <div class="my-4 border-b border-gray-200"></div>

        <div class="flex flex-row">
          <div class="basis-2/3">
            <div *ngIf="isVotingActionsVisible">
              <div class="w-1/2 body-default-bold">My Vote</div>
              <div *ngIf="!hasVoted">No vote placed</div>
                <div *ngIf="hasVoted" class="flex flex-row items-center">
                  <span class="mr-2 material-symbols-rounded"
                    [ngStyle]="{'color': userVoteOption?.color}">{{userVoteOption?.icon}}</span>
                  <span class="body-default-bold" id="user-current-vote">{{userVoteOption?.text}}</span>
                  <span id="user-vote-created-date">&nbsp;-&nbsp;placed on {{userVoteSubmittedDate}}</span>
                </div>

                <div id="voting-action" class="flex flex-row gap-4 mt-4" *ngIf="!isInternalPublicUser">

                <button class="w-1/5 btn btn-primary h-[50px]" [disabled]="!isVoteButtonEnable"
                (click)="openPlaceVoteModal()" id="place-vote-Button">{{hasVoted ? 'Change Vote' : 'Place Vote'}}</button>

                </div>
            </div>
          </div>

          <div class="flex justify-end h-9 basis-1/3">
            <a (click)="downloadCommentTemplate()"
              class="block mt-1 overflow-hidden leading-6 cursor-pointer text-link text-ellipsis whitespace-nowrap"
              id="">{{commentTemplate?.overview?.metadata?.filename}}

            </a>

            <span *ngIf="commentTemplate"  class="ml-2 text-2xl text-blue-800 cursor-pointer material-symbols-rounded" placement="right"
              #popover="ngbPopover" [ngbPopover]="helpNote" [autoClose]="'outside'"
              popoverClass="legend-popover-custom-class">
              {{ help }}
            </span>

            <ng-template #helpNote>
              <div class="text-gray-700 body-default-regular">
                If you have any comments for this IEC Draft, please download the Comments template here and email to your
                PM once completed.
              </div>
            </ng-template>
          </div>
        </div>

      </div>
    </div>

  </app-card>

  <app-card>
    <div class="flex flex-col w-full">
      <app-iec-eligible-voters [ballotVotes]="this.iecBallotDetail?.iecBallotVotes??[]" [isJoint] = "false" [BallotStatus] = "ballotStatusId" [iecBallotDetail] = "iecBallotDetail"></app-iec-eligible-voters>
    </div>
  </app-card>
</div>
